/**
 * 采集批次服务模块：处理素材包（采集批次）数据
 */

import { apiService } from './api'
import type {
  CrawlBatch,
  CrawlBatchListParams,
  CrawlBatchListResponse,
  ApiResponse,
} from '@/types/crawlBatch'

const CRAWL_BATCH_ENDPOINT = '/api/user/crawl-batches' as const

/**
 * 获取批次列表
 * @param params 查询参数
 * @returns 批次列表
 */
export async function listCrawlBatches(
  params?: CrawlBatchListParams
): Promise<CrawlBatchListResponse> {
  const queryParams: Record<string, string> = {}

  if (params !== undefined) {
    if (params.current !== undefined) {
      queryParams['current'] = String(params.current)
    }
    if (params.pageSize !== undefined) {
      queryParams['pageSize'] = String(params.pageSize)
    }
    if (params.platform !== undefined) {
      queryParams['platform'] = params.platform
    }
    if (params.status !== undefined) {
      queryParams['status'] = params.status
    }
    if (params.remark !== undefined && params.remark !== '') {
      queryParams['remark'] = params.remark
    }
  }

  const response = await apiService.get<ApiResponse<CrawlBatchListResponse>>(
    CRAWL_BATCH_ENDPOINT,
    queryParams
  )
  return response.data
}

/**
 * 获取批次详情
 * @param id 批次 ID
 * @returns 批次详情
 */
export async function getCrawlBatch(id: string): Promise<CrawlBatch> {
  const response = await apiService.get<ApiResponse<CrawlBatch>>(
    `${CRAWL_BATCH_ENDPOINT}/${id}`
  )
  return response.data
}

/**
 * 删除批次（级联删除关联商品）
 * @param id 批次 ID
 * @returns 删除结果
 */
export async function deleteCrawlBatch(
  id: string
): Promise<{ message: string }> {
  const response = await apiService.delete<
    ApiResponse<{ message: string }>
  >(`${CRAWL_BATCH_ENDPOINT}/${id}`)
  return response.data
}
